import React, { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { usePatchObservationMutation } from '../../../modules/reportingTournees/reportingTournees.api';

export default function ObservationCell({ row }) {
  const [value, setValue] = useState(row.observation ?? '');
  const [editing, setEditing] = useState(false);
  const [patchObservation, { isLoading, isError }] = usePatchObservationMutation();

  useEffect(() => {
    setValue(row.observation ?? '');
  }, [row.observation]);

  const handleSave = () => {
    const trimmed = value.trim();
    if (trimmed !== (row.observation ?? '').trim()) {
      patchObservation({ id: row.id, observation: trimmed });
    }
    setEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSave();
    if (e.key === 'Escape') {
      setValue(row.observation ?? '');
      setEditing(false);
    }
  };

  if (editing) {
    return (
      <TextField
        size="small"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        autoFocus
        disabled={isLoading}
        sx={{ minWidth: 150 }}
        error={isError}
      />
    );
  }

  return (
    <Box
      onClick={() => setEditing(true)}
      sx={{ cursor: 'pointer', minHeight: 22, minWidth: 110, '&:hover': { textDecoration: 'underline dotted' } }}
      title="Cliquer pour éditer"
    >
      {value || <span style={{ color: '#aaa' }}>—</span>}
    </Box>
  );
}
